import { render } from "./CustomLabelCheckbox.vue?vue&type=template&id=10fe1ed4"
import script from "./CustomLabelCheckbox.vue?vue&type=script&lang=js"
export * from "./CustomLabelCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__